'use strict';

module.exports = 'enhance';